"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var codemirror_component_1 = require("./codemirror.component");
/**
 * CodemirrorModule
 */
var CodemirrorModule = (function () {
    function CodemirrorModule() {
    }
    return CodemirrorModule;
}());
CodemirrorModule = __decorate([
    core_1.NgModule({
        declarations: [
            codemirror_component_1.CodemirrorComponent,
        ],
        exports: [
            codemirror_component_1.CodemirrorComponent,
        ]
    })
], CodemirrorModule);
exports.CodemirrorModule = CodemirrorModule;
//# sourceMappingURL=codemirror.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-codemirror/lib/codemirror.module.js
// module id = 488
// module chunks = 4